import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle, BookOpen } from "lucide-react";
import { Logo } from "./Logo";
import { WA } from "./data";
import { scrollToId, ease } from "./motion";

const LINKS = [["produtos", "Produtos"], ["loja", "A Loja"], ["avaliacoes", "Avaliações"], ["visite", "Como chegar"]];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <motion.header
      initial={{ y: -80 }} animate={{ y: 0 }} transition={{ duration: 1, ease, delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 border-b ${scrolled ? "bg-[#0A0E3F]/75 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"}`}
      data-testid="site-nav"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-[72px] flex items-center justify-between">
        <a href="#topo" onClick={(e) => scrollToId(e, "topo")} data-testid="nav-logo-link"><Logo /></a>
        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map(([id, label]) => (
            <a key={id} href={`#${id}`} onClick={(e) => scrollToId(e, id)} data-testid={`nav-link-${id}`}
              className="group relative text-sm text-white/85 hover:text-white transition-colors">
              {label}
              <span className="absolute -bottom-1 left-0 h-px w-full bg-[#FF6A13] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
        <a href="https://canva.link/catalogo-rsilva" target="_blank" rel="noopener noreferrer" data-testid="nav-catalog-btn" aria-label="Ver catálogo"
          className="group inline-flex items-center gap-2 rounded-full border border-white/25 text-white font-semibold text-sm px-3 sm:px-5 py-2.5 hover:border-white hover:bg-white/5 transition-colors duration-300">
          <BookOpen className="w-4 h-4 transition-transform duration-300 group-hover:-rotate-12" />
          <span className="hidden sm:inline">Ver catálogo</span>
        </a>
        <a href={WA} target="_blank" rel="noreferrer" data-testid="nav-whatsapp-btn"
          className="group inline-flex items-center gap-2 rounded-full bg-[#FF6A13] hover:bg-[#FFB020] text-[#0A0E3F] font-semibold text-sm px-4 md:px-5 py-2.5 transition-colors duration-300">
          <MessageCircle className="w-4 h-4 transition-transform duration-300 group-hover:-rotate-12" />
          <span className="hidden sm:inline">Fale no WhatsApp</span><span className="sm:hidden">WhatsApp</span>
        </a>
        </div>
      </div>
    </motion.header>
  );
};
